import { Component, inject } from '@angular/core';
import { SharedErrorService } from '@luggagehero/shared/services/error';
import { TranslateService } from '@ngx-translate/core';

import { BookingActionBaseComponent } from './booking-action.base-component';

@Component({
  template: '',
  standalone: false,
})
export abstract class UndoDropOffActionBaseComponent extends BookingActionBaseComponent {
  private translate = inject(TranslateService);
  private error = inject(SharedErrorService);

  async undoCheckIn() {
    this.isLoading = true;

    try {
      const res = await this.bookingService.undoCheckIn(this.booking._id);
      this.updateBooking(res);
      this.close();
    } catch (err) {
      this.error.handleError(err, this.translate.instant('UNEXPECTED_ERROR') as string);
    }

    this.isLoading = false;
  }
}
